import React, { useEffect } from "react";
import AdminPropertyDetailsPage from "../../../pages/admin/properties/detail-pages/AdminPropertyDetailsPage";
import { useNavigate, useParams } from "react-router-dom";
import { showError, showSuccess } from "../../../utils/toastUtils";
import api from "../../../configs/api";
import { confirmAction } from "../../../utils/confirmAction";

const ActionButtons = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const handleApprove = async () => {
    const confirm = await confirmAction(
      "Approve Property?",
      "This will make the property live on the platform.",
      "Approve"
    );
    if (!confirm.isConfirmed) return;

    try {
      await api.post(`/approvals/properties/approve/${id}`);
      showSuccess("Property approved!");
      navigate("/super-admin/approvals");
    } catch (err) {
      showError("Failed to approve.");
    }
  };

  const handleReject = async () => {
    const confirm = await confirmAction(
      "Reject Property?",
      "This will reject and hide the property.",
      "Reject"
    );
    if (!confirm.isConfirmed) return;

    try {
      await api.post(`/approvals/properties/reject/${id}`, {
        reason: "Rejected by admin",
      });

      showSuccess("Property rejected.");
      navigate("/super-admin/approvals");
    } catch (err) {
      showError("Failed to reject.");
    }
  };

  return (
    <div className="flex flex-col sm:flex-row gap-3 w-full">
      {/* Reject Button */}
      <div className="w-full sm:w-1/2">
        <button
          onClick={handleReject}
          className="w-full border p-4 rounded-lg bg-[#EF492B] text-white flex items-center justify-center gap-2"
        >
          Reject Request
        </button>
      </div>

      {/* Approve Button */}
      <div className="w-full sm:w-1/2">
        <button
          onClick={handleApprove}
          className="w-full border p-4 rounded-lg bg-[#5CC184] text-white flex items-center justify-center gap-2"
        >
          Approve Request
        </button>
      </div>
    </div>
  );
};

const PropertyApprovalDetails = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className=" bg-background font-poppins">
      <main className="max-w-full mx-auto px-4 sm:px-6 py-4 sm:py-6">
        <button
          onClick={() => navigate(-1)}
          className="mb-4 px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg text-gray-700 font-medium"
        >
          ← Back
        </button>
        <AdminPropertyDetailsPage />
        <ActionButtons />
      </main>
    </div>
  );
};

export default PropertyApprovalDetails;
